ko.bindingHandlers.validationMsg = {
  init: function(element) {
    var $element;
    $element = $(element);
    $element.css({
      display: 'none'
    });
    $element.removeClass('hide');
    $element.addClass('validationMessage');
  },
  update: function(element, valueAccessor) {
    var $element, config, error, isCurrentlyVisible, isModified, isValid, isVisible, obsv;
    obsv = valueAccessor();
    config = libraries.knockoutValidation ? ko.validation.utils.getConfigOptions(element) : {};
    isModified = false;
    isValid = false;
    $element = $(element);
    if (obsv === null || typeof obsv === 'undefined') {
      throw new Error('Cannot bind validationMessage to undefined value. data-bind expression: ' + element.getAttribute('data-bind'));
    }
    if ($element.data('debounce')) {
      window.clearTimeout($(element).data('debounce'));
    }
    isModified = obsv.isModified && obsv.isModified();
    isValid = obsv.isValid && obsv.isValid();
    error = null;
    if (!config.messagesOnModified || isModified) {
      error = isValid ? null : obsv.error;
    }
    isVisible = !config.messagesOnModified || isModified ? !isValid : false;
    isCurrentlyVisible = element.style.display !== 'none';
    if (config.allowHtmlMessages) {
      ko.utils.setHtml(element, error);
    } else {
      ko.bindingHandlers.text.update(element, function() {
        return error;
      });
    }
    if (isCurrentlyVisible && !isVisible) {
      $element.data('debounce', window.setTimeout((function() {
        $element.stop().animate({
          opacity: 'hide',
          height: 'hide',
          margin: 'hide',
          padding: 'hide'
        }, 200, (libraries.jqueryUi ? 'easeInOutQuad' : 'swing'));
      }), 30));
    } else if (!isCurrentlyVisible && isVisible) {
      $element.data('debounce', window.setTimeout((function() {
        $element.stop().animate({
          opacity: 'show',
          height: 'show',
          margin: 'show',
          padding: 'show'
        }, 200, (libraries.jqueryUi ? 'easeInOutQuad' : 'swing'));
      }), 30));
    }
  }
};
